import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------- Service worker kill switch (belt-and-suspenders) ----------
// The previous rentanything.ai site was on Framer, which registered a SW
// against this origin. Returning visitors' browsers may still execute the
// stale Framer SW after DNS cutover and see cached content. The kill-switch
// SW at /service-worker.js handles browsers that auto-update their SW;
// this inline cleanup handles browsers that already loaded fresh HTML and
// just need any straggler registrations + caches nuked.
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  // Reload when the kill-switch SW asks us to (some browsers disallow
  // client.navigate() inside the SW and fall back to this message).
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "SW_KILLSWITCH_RELOAD") {
      window.location.reload();
    }
  });

  // Proactively unregister any service worker on first load.
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {});
      });
    })
    .catch(() => {});

  // And clear all CacheStorage entries on first load too.
  if (typeof window !== "undefined" && window.caches && caches.keys) {
    caches
      .keys()
      .then((names) => {
        names.forEach((name) => {
          caches.delete(name).catch(() => {});
        });
      })
      .catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
